module.exports = __webpack_public_path__ + "static/media/s20.fb21edf9.png";